import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { TextSubtitle, TextSubtitleProps } from './TextSubtitle';

export interface StandaloneTextSubtitleProps extends StandaloneComponentProps {
  text: string;
  options?: Omit<TextSubtitleProps, 'text'>;
}

export const StandaloneTextSubtitle: StandaloneComponent<StandaloneTextSubtitleProps> = ({
  text,
  options,
  ...props
}) => {
  return (
    <TextSubtitle {...options} {...props}>
      {text}
    </TextSubtitle>
  );
};

export default StandaloneTextSubtitle;
